import { createContext, useContext, useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from './AuthContext';

const ADMIN_UIDS = new Set((import.meta.env.VITE_ADMIN_UIDS || '').split(',').filter(Boolean));

const SubscriptionContext = createContext({ isPaid: false, loading: true });

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [isPaid, setIsPaid]   = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setIsPaid(false); setLoading(false); return; }
    setIsPaid(true);
    setLoading(false);
  }, [user?.uid]);

  return (
    <SubscriptionContext.Provider value={{ isPaid, loading }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  return useContext(SubscriptionContext);
}
